export const routes = {
    dashboard: { name: 'Overview', url: '/', title: 'Events overview' },
    map: { name: 'Map', url: '/map', title: 'Control map' }
}